import axios from 'axios';
import { getAxiosConfig, getDomainOrigin } from 'utils/serverConfig';

export async function fetchServicePartnerStatus(
    partnerId: string,
    groupName: string
): Promise<{
    is_error: boolean;
    data: any[] | null;
    error_message: string;
    statusCode?: number;
}> {
    try {
        const { data, status } = await axios({
            method: 'GET',
            url: `${getDomainOrigin()}/api/mpos/genie/onboarding/${partnerId}/service-partner/status?user_group=${groupName}`,
            ...getAxiosConfig(),
        });

        if (status === 200 && Array.isArray(data)) {
            return {
                is_error: false,
                data,
                error_message: '',
            };
        }

        return {
            is_error: true,
            data: null,
            error_message: 'Failed to load service partner status',
        };
    } catch (error: any) {
        return {
            is_error: true,
            data: null,
            error_message:
                error?.response?.data?.message ||
                'Failed to load service partner status',
            statusCode: error?.response?.status,
        };
    }
}

export async function fetchServicePartnerData(
    partnerId: string,
    groupName: string
): Promise<{
    is_error: boolean;
    data: any[] | null;
    error_message: string;
    statusCode?: number;
}> {
    try {
        const { data, status } = await axios({
            method: 'GET',
            url: `${getDomainOrigin()}/api/mpos/genie/onboarding/${partnerId}/service-partner/get-data?user_group=${groupName}`,
            ...getAxiosConfig(),
        });

        if (status === 200 && Array.isArray(data)) {
            return {
                is_error: false,
                data,
                error_message: '',
            };
        }

        return {
            is_error: true,
            data: null,
            error_message: 'Failed to load service partner data',
        };
    } catch (error: any) {
        return {
            is_error: true,
            data: null,
            error_message:
                error?.response?.data?.message ||
                'Failed to load service partner data',
            statusCode: error?.response?.status,
        };
    }
}

export async function saveServicePartnerData(
    partnerId: string,
    groupName: string,
    request: Record<string, any>
): Promise<{
    is_error: boolean;
    data: any;
    error_message: string;
    statusCode?: number;
}> {
    try {
        const { data, status } = await axios({
            method: 'POST',
            url: `${getDomainOrigin()}/api/mpos/genie/onboarding/${partnerId}/service-partner/save?user_group=${groupName}`,
            ...getAxiosConfig(),
            data: request,
        });

        if (status === 200) {
            return {
                is_error: false,
                data,
                error_message: '',
            };
        }

        return {
            is_error: true,
            data: null,
            error_message: 'Failed to save service partner data',
        };
    } catch (error: any) {
        return {
            is_error: true,
            data: null,
            error_message:
                error?.response?.data?.message ||
                'Failed to save service partner data',
            statusCode: error?.response?.status,
        };
    }
}
